"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHADOWS = void 0;
/* eslint-disable sort-keys */

var SHADOWS = exports.SHADOWS = {
  none: 'none',
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
  '2xl': 6,
  '3xl': 7
};